import _extends from "@babel/runtime/helpers/esm/extends";
import { useThemeProps as systemUseThemeProps } from '@mui/system';
import defaultTheme from './defaultTheme';
export default function useThemeProps({
  props,
  name
}) {
  return systemUseThemeProps({
    props,
    name,
    defaultTheme: _extends({}, defaultTheme, {
      components: {}
    })
  });
}